import { render, staticRenderFns } from "./headerSerc.vue?vue&type=template&id=73f997ee&scoped=true"
import script from "./headerSerc.vue?vue&type=script&lang=js"
export * from "./headerSerc.vue?vue&type=script&lang=js"
import style0 from "./headerSerc.vue?vue&type=style&index=0&id=73f997ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f997ee",
  null
  
)

export default component.exports